import { FeatureFlagManifest } from "./check-feature-flag";

export const featureFlags = {
    wacSalesInboundLeads: {
        featureFlagName: "wac_sales_inbound_leads",
        metadata: {
            description:
                "Flag to enable UI button to contact sales if user is determined to be an SMB inbound sales lead",
            expectedReleaseDate: "10/05/2025",
            expectedRuntime: "12 weeks",
            context: {
                // feature is also on "/try", which is a magnolia page
                urls: ["/"]
            }
        }
    },
    preloadAtlaskitStyles: {
        featureFlagName: "token-style-wrapper-wac-web-gate",
        metadata: {
            description: "Flag to enable optimized Atlas token head loading.",
            expectedReleaseDate: "08/30/2025",
            expectedRuntime:
                "Can be cleaned up after monitored in PROD and ensure no issues",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    uniformPersonalizationEnabled: {
        featureFlagName: "uniform_personalization_component_enabled",
        metadata: {
            description:
                "Feature gate to enable personalization of components in Uniform. Returns default when disabled",
            expectedReleaseDate: "8/15/2025",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    jsmPaidLpAuxiaIntegration: {
        featureFlagName: "jsm-paid-lp-auxia-integration",
        metadata: {
            description:
                "Feature gate to roll out Auxia integration for JSM Paid LP Anchor pages",
            expectedReleaseDate: "9/22/2025",
            expectedRuntime: "12 weeks",
            context: {
                urls: ["/software/jira/service-management"]
            }
        }
    },
    uniformLazyLoading: {
        featureFlagName: "uniform-lazy-loading-enabled",
        metadata: {
            description:
                "Feature gate to enable lazy loading for Uniform components. Falls back to eager loading when disabled",
            expectedReleaseDate: "9/15/2025",
            expectedRuntime: "4 weeks for performance validation",
            context: {
                urls: ["/customers/*"]
            }
        }
    },
    sxpEnableFastshiftPortal: {
        featureFlagName: "sxp-enable-fastshift-portal",
        metadata: {
            description: "Feature gate to roll out Migration FastShift Portal",
            expectedReleaseDate: "07/01/2025",
            expectedRuntime: "Duration of FastShift's first release",
            context: {
                urls: ["/fastshift/dashboard"]
            }
        }
    },
    sxpFastshiftPortalChatAgent: {
        featureFlagName: "sxp-fastshift-portal-chat-agent",
        metadata: {
            description: "Feature gate to enable FastShift chat agent",
            expectedReleaseDate: "30/10/2025",
            expectedRuntime: "3 Months",
            context: {
                urls: ["/fastshift/dashboard"]
            }
        }
    },
    sxpFastshiftPortalEnableEngagementCallInProduction: {
        featureFlagName: "sxp-fastshift-portal-enable-prod-engagement",
        metadata: {
            description:
                "Temporary flag, affects production only. When off, smart link mocks are shown. When on, true backend engagement is called to retrieve smart link urls. This flag has been added to enable dual testing pre-release.",
            expectedReleaseDate: "10/10/2025",
            expectedRuntime: "About 3 weeks",
            context: {
                urls: ["/fastshift/{domainId}/planning"]
            }
        }
    },
    sxpFastshiftPortalDisableAuthHookTestingOnly: {
        featureFlagName: "sxp-fastshift-portal-temp-disable-auth-hook",
        metadata: {
            description:
                "This flag is for enabling ongoing developer testing in light of unrelated data issues. Enabling this flag causes a BROKEN routing experience for the user. This flag should only ever be enabled as a dev override for specific test accounts, for specific testing purposes. Once GSAC Migration issues are resolved, this flag should be made redundant and removed from the codebase. ",
            expectedReleaseDate: "1/10/2025",
            expectedRuntime: "About 1 week",
            context: {
                urls: ["/fastshift/*"]
            }
        }
    },
    sxpFastshiftPortalEnableCustomerFeedback: {
        featureFlagName: "sxp-fastshift-portal-enable-customer-feedback",
        metadata: {
            description:
                "Feature gate to enable customer feedback in FastShift Portal",
            expectedReleaseDate: "10/27/2025",
            expectedRuntime: "1 month",
            context: {
                urls: ["/fastshift/**"]
            }
        }
    },
    gwp1304AddIntercomToJpdProductTour: {
        featureFlagName: "gwp-1304-add-intercom-to-jpd-product-tour",
        metadata: {
            description: "Add Intercom to JPD Product Tour",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira/product-discovery"]
            }
        }
    },
    jiraOnboardingMultipleProjectRequestsBugfix: {
        featureFlagName: "jira_onboarding_multiple_project_requests_bugfix",
        metadata: {
            description:
                "Feature gate to roll out bugfix for multiple project requests and prevent empty redirect url in jira onboarding",
            expectedReleaseDate: "6/18/2025",
            expectedRuntime: "",
            context: {
                urls: ["/ondemand/signup/confirmation"]
            }
        }
    },
    jiraOnboardingAiMadlib: {
        featureFlagName: "jira-onboarding-ai-madlib-gate",
        metadata: {
            description: "Feature gate for AI Madlib in Jira onboarding",
            expectedReleaseDate: "11/18/2025",
            expectedRuntime: "",
            context: {
                urls: ["/ondemand/signup/confirmation"]
            }
        }
    },
    resolveTenantIdBeforeOnboarding: {
        featureFlagName: "jira_onboarding_resolve_tenant_id_gate",
        metadata: {
            description: "Feature gate to resolve tenantId before onboarding",
            expectedReleaseDate: "10/16/2025",
            expectedRuntime: "7 days",
            context: {
                urls: ["/ondemand/signup/confirmation"]
            }
        }
    },
    signupModuleDeprecation: {
        featureFlagName: "signup-module-deprecation",
        metadata: {
            description: "Deprecate SignupModule (aka BXP-UI)",
            expectedReleaseDate: "9/30/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    signupTwcUpliftFrontend: {
        featureFlagName: "signup-twc-uplift-frontend",
        metadata: {
            description: "Enable Teamwork Collection uplift for signup flow",
            expectedReleaseDate: "11/11/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    signupTwcSwitchSiteRovoCta: {
        featureFlagName: "signup-twc-switch-site-rovo-cta-gate",
        metadata: {
            description:
                "Enable chat URL for Rovo CTA on TWC switch site screen",
            expectedReleaseDate: "11/17/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    wacWebExtendedCachingOfBfldrAssetsForJsw: {
        featureFlagName: "wac-web-extended-caching-of-bfldr-assets-for-jsw",
        metadata: {
            description: "WAC Web Extended Caching of Bfldr Assets for JSW",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    wacWebTrafficAAGate: {
        featureFlagName: "wac-web-traffic-aa-gate",
        metadata: {
            description: "WAC Web Traffic AA Gate",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    gwp5158FocusProductAdd: {
        featureFlagName: "gwp-5158-focus-product-add",
        metadata: {
            description: "Adding Focus to global nav",
            expectedReleaseDate: "April 9, 2025",
            expectedRuntime:
                "Forever (gate to be used for Team launch, will be cleaned up)",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    gwp4947Team25HeroHomepageTakeover: {
        featureFlagName: "gwp-4947-team-25-hero-homepage-takeover",
        metadata: {
            description: "Team 25 hero takeover",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: ["/", "/enterprise"]
            }
        }
    },
    gwp5046TurboBannerEnterprise: {
        featureFlagName: "gwp-5046-turbo-banner-enterprise",
        metadata: {
            description: "Turbo racing banner",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: ["/enterprise"]
            }
        }
    },
    gwp5381AddIntercomWidgetToUniform: {
        featureFlagName: "gwp-5381-add-intercom-widget-to-uniform",
        metadata: {
            description: "Add Intercom widget to Uniform Page component",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/customers/*"]
            }
        }
    },
    wacProductsLoomURL: {
        featureFlagName: "wac-products-loom-url",
        metadata: {
            description: "Change loom URL",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    asyncArchitectureSiteCreation: {
        featureFlagName: "async-architecture-frontend-gate",
        metadata: {
            description:
                "Feature gate to enable async architecture site creation for JSM n2n",
            expectedReleaseDate: "03/31/2025",
            expectedRuntime: "",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    edgeLambdaCacheProductDiscovery: {
        featureFlagName: "edge-lambda-cache-product-discovery",
        metadata: {
            description:
                "Flag to enable edge lambda caching for product discovery page",
            expectedReleaseDate: "03/18/2025",
            expectedRuntime: "Indefinite",
            context: {
                urls: [
                    "/software/jira/product-discovery",
                    "/",
                    "/customers*",
                    "/software/confluence/templates*"
                ]
                // TODO: GWP-8863 Update regex handler - /software/confluence/templates/categories or /software/confluence/templates/search are not going through edge cache
            }
        }
    },
    wacWebUseEsModulesScripts: {
        featureFlagName: "wac-web-use-esmodules-scripts",
        metadata: {
            description: "Use Esmodules script",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    signupPopBackBtn: {
        featureFlagName: "signup-pop-back-btn",
        metadata: {
            description:
                "Show back button in post order signup site picker page",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: ["/buy/cloud/site-setup"]
            }
        }
    },
    gwp5548Team25DuringEventBanner: {
        featureFlagName: "gwp-5548-team-25-during-event-banner",
        metadata: {
            description: "Team 25 During event banner",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "1 day",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp5421CollectionsHero: {
        featureFlagName: "gwp-5421-collections-hero",
        metadata: {
            description: "Collections hero takeover on homepage",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    voltronEnterpriseContactForm: {
        featureFlagName: "voltron-enterprise-contact-form",
        metadata: {
            description: "Sends utms values in the form submission payload",
            expectedReleaseDate: "4/11",
            expectedRuntime: "indefinite",
            context: {
                urls: []
            }
        }
    },
    gwp8165EnterpriseContactServiceCollection: {
        featureFlagName: "gwp-8165-enterprise-contact-service-collection",
        metadata: {
            description:
                "Feature gate to enable Service Collection option in enterprise contact forms",
            expectedReleaseDate: "10/01/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/enterprise/contact"]
            }
        }
    },
    voltronGupsDataInAnalyticsWrapper: {
        featureFlagName: "voltron-gups-data-in-analytics-wrapper",
        metadata: {
            description:
                "Add gups storage and retrieval of utm data in analytics wrapper",
            expectedReleaseDate: "4/11/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp737EnableIntercomChatHome: {
        featureFlagName: "gwp-737-enable-intercom-chat-home",
        metadata: {
            description: "Triggers boot intercom on home page",
            expectedReleaseDate: "",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    wacLiftedBannerSticky: {
        featureFlagName: "wac-lifted-banner-sticky",
        metadata: {
            description: "Lifted banner sticky",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/",
                    "/software/confluence",
                    "/jira",
                    "/software/jira/service-management",
                    "/software/jira"
                ]
            }
        }
    },
    gwp5682RemoveRovoFromPricingForm: {
        featureFlagName: "gwp-5682-remove-rovo-from-pricing-form",
        metadata: {
            description: "Remove rovo from pricing form",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/enterprise/contact"]
            }
        }
    },
    gwp6474RemoveOpsgenieContactSalesForm: {
        featureFlagName: "gwp-6474-remove-opsgenie-contact-sales-form",
        metadata: {
            description: "Remove rovo from contact form",
            expectedReleaseDate: "06/04/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/enterprise/contact"]
            }
        }
    },
    jiraProductDiscoveryPremiumWacUpdates: {
        featureFlagName: "jira-product-discovery-premium-wac-updates",
        metadata: {
            description:
                "Updates to the JPD Pricing page on WAC for Premium GA. https://hello.jira.atlassian.cloud/browse/GWP-5783",
            expectedReleaseDate: "4/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/jira/product-discovery/pricing"]
            }
        }
    },
    enterprisePageDXPMigration: {
        featureFlagName: "enterprise-page-dxp-migration",
        metadata: {
            description: "Enterprise Page DXP Migration",
            expectedReleaseDate: "7/1/2025",
            expectedRuntime: "",
            context: {
                urls: ["/enterprise"]
            }
        }
    },
    jiraTemplatesDxpMigration: {
        featureFlagName: "jira-templates-dxp-migration",
        metadata: {
            description: "Jira Templates DXP Migration",
            expectedReleaseDate: "6/30/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira/*"]
            }
        }
    },
    jiraFeaturesSubNav: {
        featureFlagName: "jira-features-sub-nav",
        metadata: {
            description: "Enable Dropdown sub nav for Jira UIP pages in WAC",
            expectedReleaseDate: "8/25/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira/*"]
            }
        }
    },
    confluenceTemplatesDxpMigration: {
        featureFlagName: "confluence-templates-dxp-migration",
        metadata: {
            description: "Confluence Templates DXP Migration",
            expectedReleaseDate: "8/20/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/confluence/templates/*"]
            }
        }
    },
    gwp6825WebinarBanner: {
        featureFlagName: "gwp-6825-webinar-banner",
        metadata: {
            description: "GWP-6825 Webinar Banner",
            expectedReleaseDate: "6/24/2025",
            expectedRuntime: "4 weeks",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp8404Team25EuBannerPhase5: {
        featureFlagName: "gwp-8404-team-25-eu-banner-phase-5",
        metadata: {
            description: "GWP-8404 Team 25 Europe banner - Phase 5",
            expectedReleaseDate: "10/04/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp8238BannerAnnouncement: {
        featureFlagName: "gwp-8238-banner-announcement",
        metadata: {
            description:
                "GWP-8238 Banner announcement for homepage and Jira software page",
            expectedReleaseDate: "9/18/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/", "/software/jira"]
            }
        }
    },
    gwp6473JpdPremiumBanner: {
        featureFlagName: "gwp-5810-nonprofit-pricing-changes",
        metadata: {
            description: "JPD Premium Announcement",
            expectedReleaseDate: "6/03/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira/product-discovery",
                    "/software/jira/product-discovery/pricing"
                ]
            }
        }
    },
    jfindLoggedInJiraProductTourSkeleton: {
        featureFlagName: "logged-in-jira-pt-skeleton-feature-gate",
        metadata: {
            description: "JFIND-1543 Skeleton for Logged In Jira Product Tour",
            expectedReleaseDate: "06/05/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    wacUipButterBarJsmGate: {
        featureFlagName: "wac-uip-butter-bar-jsm-gate",
        metadata: {
            description: "Forrester banner",
            expectedReleaseDate: "unknown",
            expectedRuntime: "unknown",
            context: {
                urls: ["/software/jira/service-management"]
            }
        }
    },
    gwp6701ForresterBanner: {
        featureFlagName: "gwp-6701-forrester-banner",
        metadata: {
            description: "Forrester banner",
            expectedReleaseDate: "6/16/2025",
            expectedRuntime: "Two weeks",
            context: {
                urls: ["/software/jira/service-management"]
            }
        }
    },
    gwp6524OpsgenieSignupEol: {
        featureFlagName: "gwp-6524-opsgenie-signup-eol",
        metadata: {
            description: "Opsgenie EOL",
            expectedReleaseDate: "6/04/2025",
            expectedRuntime: "Operational Flag",
            context: {
                urls: ["/try/cloud/signup?bundle=jira-service-desk"]
            }
        }
    },
    gwpUniformLinkLocalizePartnerDirectory: {
        featureFlagName: "gwp-uniform-link-localize-partner-directory",
        metadata: {
            description: "Uniform Link to localize Partner Directory urls",
            expectedReleaseDate: "6/13/2025",
            expectedRuntime: "Operational Flag",
            context: {
                urls: ["/customers/*"]
            }
        }
    },
    gwp6837NavTalentGa: {
        featureFlagName: "gwp-6837-nav-talent-ga",
        metadata: {
            description: "Add Talent GA to Global Nav",
            expectedReleaseDate: "6/30/2025",
            expectedRuntime:
                "Forever (gate to be used for launch, will be cleaned up)",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    localizeAbsoluteWacUrls: {
        featureFlagName: "localize-absolute-wac-urls",
        metadata: {
            description: "Localize absolute WAC URLs",
            expectedReleaseDate: "7/17/2025",
            expectedRuntime: "Operational Flag",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    jiraPricingPageWaeMigration: {
        featureFlagName: "gwp-7304-jira-pricing-page-wae-migration",
        metadata: {
            description: "migration of Jira pricing page to WAE",
            expectedReleaseDate: "8/15/2025",
            expectedRuntime: "TBD", // todo: @bsparks GWP-7529
            context: {
                urls: ["/software/jira/pricing"]
            }
        }
    },
    confluencePricingPageWaeMigration: {
        featureFlagName: "gwp-6915-confluence-pricing-page-wae-migration",
        metadata: {
            description: "migration of Confluence pricing page to WAE",
            expectedReleaseDate: "9/2/2025",
            expectedRuntime: "TBD", //
            context: {
                urls: ["/software/confluence/pricing"]
            }
        }
    },
    gwp7856PricingPagesWaeMigrationM3: {
        featureFlagName: "gwp-7856-pricing-pages-wae-migration-m3-1",
        metadata: {
            description: "migration of pricing pages to WAE, milestone-3",
            expectedReleaseDate: "ongoing",
            expectedRuntime: "",
            context: {
                urls: [
                    "/collections/teamwork/pricing",
                    "/collections/strategy/pricing",
                    "/software/guard/pricing",
                    "/software/compass/pricing",
                    "/software/loom/pricing"
                    // ...add more pricing urls here
                ]
            }
        }
    },
    gwpAJContextualBanditsJira: {
        featureFlagName: "gwp-aj-contextual-bandits-jira-gate",
        metadata: {
            description: "Contextual bandits for Jira",
            expectedReleaseDate: "8/15/2025",
            expectedRuntime: "13 weeks", // todo: @bsparks GWP-7529
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    gwpAJContextualBanditsConfluence: {
        featureFlagName: "gwp-aj-contextual-bandits-confluence-gate",
        metadata: {
            description: "Contextual bandits for Confluence",
            expectedReleaseDate: "8/15/2025",
            expectedRuntime: "13 weeks", // todo: @bsparks GWP-7529
            context: {
                urls: ["/software/confluence"]
            }
        }
    },
    routingTable: {
        featureFlagName: "wac-routing-table-gate",
        metadata: {
            description:
                "Uses wac-routing-table to identify Uniform-supported pages in WACs",
            expectedReleaseDate: "8/07/2025",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    gwp7617JiraShortTermAiInfusionGate: {
        featureFlagName: "gwp-7617-jira-short-term-ai-infusion-gate",
        metadata: {
            description: "Short term updates to Jira page",
            expectedReleaseDate: "8/21/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/jira"]
            }
        }
    },
    gwp7999JiraFeatures: {
        featureFlagName: "gwp-7999-jira-features",
        metadata: {
            description:
                "Feature gate to conditionally hide tabs section on Jira features page",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                urls: ["/software/jira/features"]
            }
        }
    },
    gwp7735GuardWebinar: {
        featureFlagName: "gwp-7735-guard-webinar",
        metadata: {
            description: "Webinar banner",
            expectedReleaseDate: "8/21/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/software/guard/pricing"]
            }
        }
    },
    gwp8240ButterbarGuard: {
        featureFlagName: "gwp-8240-butterbar-guard",
        metadata: {
            description: "Guard workshop banner",
            expectedReleaseDate: "11/11/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/guard/pricing"]
            }
        }
    },
    enableBitbucketCcpProvisioningWac: {
        featureFlagName: "enable_bitbucket_ccp_provisioning_wac",
        metadata: {
            description: "Enable Bitbucket CCP provisioning in WAC",
            expectedReleaseDate: "9/08/2025",
            expectedRuntime: "5 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    },
    gwp7546ConfluencePricingCtaCtaUrlSource: {
        featureFlagName: "gwp-7546-confluence-pricing-cta-ctaurlsource",
        metadata: {
            description:
                "Change the Confluence pricing ctaUrlSource to productPlans",
            expectedReleaseDate: "8/22/2025",
            expectedRuntime: "",
            context: {
                urls: ["/software/confluence/pricing"]
            }
        }
    },
    gwp7518NavIconUpdates: {
        featureFlagName: "gwp-7518-nav-icon-updates",
        metadata: {
            description: "Update icons on global nav",
            expectedReleaseDate: "8/29/2025",
            expectedRuntime: "",
            context: {
                urls: ["/*"]
            }
        }
    },
    gwp7711Team25BannerPhase3: {
        featureFlagName: "gwp-7711-team-25-banner-phase-3",
        metadata: {
            description: "Team 25 banner phase 3",
            expectedReleaseDate: "9/1/2025",
            expectedRuntime: "1 month",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp7456JpdStateOfProductBanner: {
        featureFlagName: "gwp-7456-jpd-state-of-product-banner",
        metadata: {
            description: "Enable JPD State of Product Banner",
            expectedReleaseDate: "9/3/2025",
            expectedRuntime: "7 days",
            context: {
                urls: ["/software/jira/product-discovery"]
            }
        }
    },
    gwp8038JpdBannerWebinar: {
        featureFlagName: "gwp-8038-jpd-banner-webinar",
        metadata: {
            description:
                "Enable JPD webinar banner to replace State of Product banner",
            expectedReleaseDate: "9/11/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/software/jira/product-discovery"]
            }
        }
    },
    improveWizardProjectCreateUfoErrorLogsGate: {
        featureFlagName: "improve_wizard_project_create_ufo_error_logging",
        metadata: {
            description:
                "Improve error logging for the project creation step in the onboarding wizard",
            expectedReleaseDate: "5/09/2025",
            expectedRuntime: "",
            context: {
                urls: ["/*"]
            }
        }
    },
    EnableJPDXflowLofiSignup: {
        featureFlagName: "gwp-7564-integrate-jpd-xflow-lofi-signup",
        metadata: {
            description: "Enable JPD Xflow Lofi Signup",
            expectedReleaseDate: "8/28/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp7942JsmWebinarGate: {
        featureFlagName: "gwp-7942-jsm-webinar-gate",
        metadata: {
            description: "JSM Webinar Banner for Atlassian Connect event",
            expectedReleaseDate: "9/15/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/software/jira/service-management"]
            }
        }
    },
    enableRovoDevStandardSignup: {
        featureFlagName: "rovo_dev_standard_signup",
        metadata: {
            description: "Enable Rovo Dev Standard Signup",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    enableCrossflowPassCloudIdParamForSignup: {
        featureFlagName: "wac-crossflow-pass-cloud-id-param-for-signup",
        metadata: {
            description: "Enable Crossflow Pass Cloud Id Param For Signup",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    enableRovoDevBetaSignup: {
        featureFlagName: "rovo_dev_beta_signup_backup",
        metadata: {
            description: "Enable Rovo Dev Beta Signup",
            expectedReleaseDate: "09/19/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp7603UniformPageDwellTime: {
        featureFlagName: "gwp-7603-uniform-page-dwell-time",
        metadata: {
            description: "Enable Uniform Page Dwell Time Tracking",
            expectedReleaseDate: "9/04/2025",
            expectedRuntime: "1 week",
            context: {
                urls: ["/"]
            }
        }
    },
    agileHubArticlesDxpMigrationGate: {
        featureFlagName: "agile-hub-articles-dxp-migration-gate",
        metadata: {
            description: "Enable Agile Hub Articles DXP Migration",
            expectedReleaseDate: "9/15/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/agile/(scrum|kanban|project-management|product-management|agile-at-scale|software-development|design|agile-marketing|advantage|teams|tutorials|agile-conversations)/*",
                    "/agile/devops"
                ]
            }
        }
    },
    agileHubTutorialsDxpMigrationGate: {
        featureFlagName: "agile-hub-tutorials-dxp-migration-gate",
        metadata: {
            description: "Enable Agile Hub Tutorials DXP Migration",
            expectedReleaseDate: "9/26/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/agile/tutorials/*"]
            }
        }
    },
    agileHubTopicsDxpMigrationGate: {
        featureFlagName: "agile-hub-topics-dxp-migration-gate",
        metadata: {
            description: "Enable Agile Hub Topic Overview DXP Migration",
            expectedReleaseDate: "9/26/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/agile/(scrum|kanban|project-management|product-management|agile-at-scale|software-development|design|agile-marketing|advantage|teams|tutorials|agile-conversations)"
                ]
            }
        }
    },
    dxpMigrationJiraProductTourGate: {
        featureFlagName: "dxp-migration-jira-product-tour-gate",
        metadata: {
            description: "Enable Jira Product Tour Migration for Team 25 EU",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/jira", "/jira"]
            }
        }
    },
    gwp8037ServiceCollectionPricingPage: {
        featureFlagName: "gwp-8037-service-collection-pricing-page",
        metadata: {
            description: "Feature gate for Service Collection Pricing page",
            expectedReleaseDate: "9/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/collections/service/pricing"]
            }
        }
    },

    gwp8011RovoProductTour: {
        featureFlagName: "gwp-8011-rovo-product-tour",
        metadata: {
            description: "Feature gate for Rovo Product Tour",
            expectedReleaseDate: "10/3/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/rovo"]
            }
        }
    },
    gwp8036RovoDevPricingPage: {
        featureFlagName: "gwp-8036-rovo-dev-pricing-page",
        metadata: {
            description: "Feature gate for Rovo Dev pricing page",
            expectedReleaseDate: "9/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/rovo-dev/pricing"]
            }
        }
    },
    gwp7869NonprofitPricingPageUpdates: {
        featureFlagName: "gwp-7869-nonprofit-pricing-page-updates",
        metadata: {
            description: "Updates to Nonprofit pricing page",
            expectedReleaseDate: "9/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/teams/nonprofits/discount-pricing"]
            }
        }
    },
    gwp7923NewJsmRouteDeIndex: {
        featureFlagName: "gwp-7923-new-jsm-route-de-index",
        metadata: {
            description:
                "Feature gate for new JSM route, and de-indexing old route",
            expectedReleaseDate: "9/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira/service-management/pricing",
                    "/software/jira/service-management/product-pricing"
                ]
            }
        }
    },
    dxpMigrationConfluenceProductTourGate: {
        featureFlagName: "dxp-migration-confluence-product-tour-gate",
        metadata: {
            description:
                "Enable Confluence Product Tour Migration for Team 25 EU",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime:
                "Forever (gate to be used for launch, will be cleaned up after)",
            context: {
                urls: ["software/confluence"]
            }
        }
    },
    dxpMigrationJsmProductTourGate: {
        featureFlagName: "dxp-migration-jsm-product-tour-gate",
        metadata: {
            description: "Enable JSM Product Tour Migration for Team 25 EU",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime:
                "Forever (gate to be used for launch, will be cleaned up after)",
            context: {
                urls: ["software/jira/service-management"]
            }
        }
    },
    gwpRovoProductTourStudioTab: {
        featureFlagName: "gwp-rovo-product-tour-studio-tab",
        metadata: {
            description:
                "Update copy and CTA for Rovo Product Tour Studio Tab on Oct 8",
            expectedReleaseDate: "10/08/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["software/rovo"]
            }
        }
    },
    jfindProjectCreatedCheck: {
        featureFlagName: "jfind-project-created-check",
        metadata: {
            description:
                "adds check to ensure project is created in the onboarding wizard only 1X",
            expectedReleaseDate: "10/01/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/ondemand/signup/confirmation"]
            }
        }
    },
    gwp7850GlobalNavChangesForTeam25Eu: {
        featureFlagName: "gwp-7850-global-nav-changes-for-team-25-eu",
        metadata: {
            description: "global nav changes for team 25 eu",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    gwp7823AnimationOverlayOption: {
        featureFlagName: "gwp-7823-animation-overlay-option",
        metadata: {
            description: "Feature gate for animation overlay option",
            expectedReleaseDate: "10/03/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/rovo"]
            }
        }
    },
    gwp8279CollectionHeroIntl: {
        featureFlagName: "gwp-8279-collection-hero-intl",
        metadata: {
            description:
                "Enables hardcoded translation strings in the collection-pricing-hero component",
            expectedReleaseDate: "10/06/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/collection/service/pricing",
                    "/collection/teamwork/pricing",
                    "/collection/strategy/pricing"
                ]
            }
        }
    },
    signupPopEnhancementErrorMessageCommit18428: {
        featureFlagName: "signup-pop-enhancement-error-message-commit-18428",
        metadata: {
            description:
                "Feature gate for signup pop enhancement error message commit 18428",
            expectedReleaseDate: "11/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/buy/cloud/post-order-provisioning",
                    "/buy/cloud/site-setup"
                ]
            }
        }
    },
    signupPopEnhancementCommit18428: {
        featureFlagName: "signup-pop-enhancement-commit-18428",
        metadata: {
            description: "Feature gate for signup pop enhancement commit 18428",
            expectedReleaseDate: "11/30/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/buy/cloud/org-setup"]
            }
        }
    },
    iosSmartBanner: {
        featureFlagName: "wac_ios_smart_banner",
        metadata: {
            description: "Feature gate for iOS smart banner",
            expectedReleaseDate: "10/22/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/jira", "/software/confluence"]
            }
        }
    },
    wacSearchIndexV3_2: {
        featureFlagName: "wac_search_index_v3-2",
        metadata: {
            description: "Feature gate for search index v3-2",
            expectedReleaseDate: "10/23/2025",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    gwp8510AustinGrandPrixBanner: {
        featureFlagName: "gwp-5810-austin-grand-prix",
        metadata: {
            description: "Austin Grand Prix banner on homepage",
            expectedReleaseDate: "10/14/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/"]
            }
        }
    },
    gwp8577ServiceCollectionBanners: {
        featureFlagName: "gwp-8577-service-collection-banners",
        metadata: {
            description: "Feature gate for service collection banners",
            expectedReleaseDate: "11/03/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: ["/software/jira/service-management"]
            }
        }
    },
    twcg790AATest: {
        featureFlagName: "twcg-790-contextual-background-aa",
        metadata: {
            description: "Feature gate for TWCG-790 AA test",
            expectedReleaseDate: "11/07/2025",
            expectedRuntime: "2 weeks",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: ["*"]
            }
        }
    },
    siteActivationUpgradableProductsInSignup: {
        featureFlagName: "site-activation-upgradable-products-in-signup",
        metadata: {
            description:
                "Feature gate for site activation upgradable products in signup",
            expectedReleaseDate: "11/12/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: ["/try/cloud/signup"]
            }
        }
    }
} satisfies FeatureFlagManifest;
